import { CommonModule } from "@angular/common";
import { Component, OnInit, ViewChild, inject } from "@angular/core";
import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule, Validators } from "@angular/forms";
import { MatButton } from "@angular/material/button";
import { MatError, MatFormField, MatLabel } from "@angular/material/form-field";
import { MatInput } from "@angular/material/input";
import { MatPaginator, MatPaginatorModule } from "@angular/material/paginator";
import { MatSort, MatSortModule } from "@angular/material/sort";
import { MatTableDataSource, MatTableModule } from "@angular/material/table";
import { ActivatedRoute, RouterModule } from "@angular/router";
import { MatChipsModule } from "@angular/material/chips";
import { TableConstants } from "../../constants/table.constant";
import { publicAuthorisedPasFilterPredicate } from "./public-authorised-pa-filter-predicate";
import { debounceTime, distinctUntilChanged } from "rxjs";
import { PublicSearchRegisteredPaItem } from "../../interfaces/public-search-registered-pa-item.interface";
import { publicAuthorisedPaSearchSortingDataAccessor } from "./public-authorised-pa-data-accessor";
import { ExactMatchDirective } from "../../directives/exact-match.directive";
import { MatIconModule } from "@angular/material/icon";
import { MatTooltipModule } from "@angular/material/tooltip";

@Component({
    selector: 'si-public-authorised-pa-search',
    templateUrl: './public-authorised-pa-search.component.html',
    styleUrls: ['./public-authorised-pa-search.component.scss'],
    standalone: true,
    imports: [
      ReactiveFormsModule,
      MatLabel,
      MatFormField,
      MatInput,
      MatError,
      MatButton,
      CommonModule,
      MatTableModule,
      MatPaginatorModule,
      MatSortModule,
      MatChipsModule,
      RouterModule,
      ExactMatchDirective,
      MatIconModule,
      MatTooltipModule,
    ],
})
export class PublicAuthorisedPaSearchComponent implements OnInit {
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  private readonly fb = inject(FormBuilder);
  private readonly route = inject(ActivatedRoute);

  public paDataSource = new MatTableDataSource<PublicSearchRegisteredPaItem>();

  public form: FormGroup;

  public columns = ['erauReference', 'organisationName'];
  public TableConstants = TableConstants;

  public ngOnInit(): void {
    this.form = this.fb.group({
      search: new FormControl('', []),
    })

    this.paDataSource.filterPredicate = publicAuthorisedPasFilterPredicate;
    this.paDataSource.data = this.route.snapshot.data.pa as PublicSearchRegisteredPaItem[];
    this.paDataSource.paginator = this.paginator;
    this.paDataSource.sort = this.sort;
    this.paDataSource.sortingDataAccessor = publicAuthorisedPaSearchSortingDataAccessor;

    this.addSubscriptions();
  }

  private addSubscriptions() {
    this.form.get('search').valueChanges.pipe(
      debounceTime(600),
      distinctUntilChanged(),
    ).subscribe((value) => {
      this.paDataSource.filter = value.trim().toLowerCase();
      this.paDataSource.paginator.firstPage();
    })
  }

  public isExactMatch(element: PublicSearchRegisteredPaItem) {
    const value = this.form.get('search').value?.trim().toLowerCase();
    return value === element.erauReference.toLowerCase() || value === element.organisationName.toLowerCase();
  }
}
